import React, { createContext } from 'react';
import { createTheming, ThemeProvider } from 'react-jss';
import { WrenchTheme as WebAssetsTheme } from '@wds/styles';

const ThemeContext = createContext({});

const theming = createTheming(ThemeContext);

const {
  ThemeProvider: WebAssetsThemeProvider,
  useTheme: useWebAssetsTheme,
} = theming;

const WebAssetsThemeWrapper = ({ children }: any) => {
  const theme = useWebAssetsTheme();
  return (
    <ThemeProvider theme={{ ...WebAssetsTheme, ...theme }}>
      {children}
    </ThemeProvider>
  );
};

export {
  WebAssetsThemeProvider,
  useWebAssetsTheme,
  WebAssetsTheme,
  WebAssetsThemeWrapper,
};
export type ThemeShape = typeof WebAssetsTheme;
